import { TagSchema } from "@redotech/redo-model/tag";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const addTagToReturn = {
  name: "addTagToReturn" as const,
  input: z.object({ returnId: zExt.objectId(), tag: TagSchema }),
  output: z.null(),
};
